
















import * as echarts from 'echarts'
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class'
import { mapGetters } from 'vuex'
import { statusWebservice } from '../../webservices/status'
import { eventWebservice } from '../../webservices/event'
import { Event } from '../../models/event'
import { Status } from '../../models/status'

@Component({
    name:'Newest',

    // Vuex bindings
      computed: mapGetters('event', [
        'newestEvent'
    ])
})

export default class Newest extends Vue {

    @Getter('event/newestEvent') newestEvent

    // Mounted is called initially
    mounted() {
        let self = this

        // Fetch newest event
        eventWebservice.getNewestEvent().then(function(event) {
            // Store in vuex
            self.$store.commit('event/setNewestEvent', event)
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/events/Status.vue